(function () {
  const STORAGE_KEY = "theme_mode"; // "light" | "dark" | "system"
  const root = document.documentElement;

  function getSystemPref() {
    return window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)").matches
      ? "dark"
      : "light";
  }

  function apply(mode) {
    if (mode === "system") {
      root.setAttribute("data-theme", getSystemPref());
      root.setAttribute("data-theme-mode", "system");
      return;
    }
    root.setAttribute("data-theme", mode);
    root.setAttribute("data-theme-mode", mode);
  }

  function readInitialMode() {
    // If theme editor provides a default via data attr, use it as fallback
    const fromHtml = root.getAttribute("data-theme-default"); // optional
    const saved = localStorage.getItem(STORAGE_KEY);
    return saved || fromHtml || "system";
  }

  const initial = readInitialMode();
  apply(initial);

  // react to system changes if on "system"
  if (window.matchMedia) {
    const mq = window.matchMedia("(prefers-color-scheme: dark)");
    mq.addEventListener?.("change", () => {
      const current = localStorage.getItem(STORAGE_KEY) || root.getAttribute("data-theme-mode") || "system";
      if (current === "system") apply("system");
    });
  }

  // expose helper for toggles
  window.__setThemeMode = function (mode) {
    localStorage.setItem(STORAGE_KEY, mode);
    apply(mode);
  };
})();
